import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const leaveStatusApi = factory.get("leaveStatus");

const initialState = {
  loading: false,
  data: [],
};

export const leaveStatusSlice = createSlice({
  name: "leaveStatus",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setData: (state, { payload }) => {
      state.data = payload.data.data ?? [];
    },
  },
});

export const { setLoading, setData } = leaveStatusSlice.actions;

export default leaveStatusSlice.reducer;

//axios
const getAll = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await leaveStatusApi.getAll();
    dispatch(setData(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const LeaveStatus = {
  getAll,
};
